module.exports = __webpack_public_path__ + "static/img/aboutUsTitle.3f152ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/aboutUsTitle.png
// module id = xlIR
// module chunks = 0